export const OWNER = {
  name: 'Schürpf Consulting',
  street: 'Chli Ebnet 1',
  city: 'CH-6403 Küssnacht am Rigi',
  email: 'gcvllc@gmail.com'
};

export const impressum = [
  {
    heading: 'Angaben gemäß § 5 DDG',
    lines: [OWNER.name, OWNER.street, OWNER.city]
  },
  {
    heading: 'Kontakt',
    lines: [`E-Mail: ${OWNER.email}`]
  },
  {
    heading: 'Haftung für Inhalte',
    lines: [
      'Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Alle Angaben sind Richtwerte und ersetzen keine Rechts- oder Steuerberatung im Einzelfall.'
    ]
  },
  {
    heading: 'Haftung für Links',
    lines: [
      'Diese Seite enthält Links zu externen Websites Dritter (z. B. Amazon), auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte ist stets der jeweilige Anbieter verantwortlich.'
    ]
  },
  {
    heading: 'Hinweis zu Affiliate- bzw. Werbelinks',
    lines: [
      'Links zu Amazon führen zum Buchangebot. Das Buch ist unter dem Titel „Auswandern in die Schweiz – Der große Praxisratgeber für Deutsche“ erhältlich.'
    ]
  }
];

export const datenschutz = [
  {
    heading: '1. Verantwortlicher',
    lines: [
      `${OWNER.name}, ${OWNER.street}, ${OWNER.city}`,
      `E-Mail: ${OWNER.email}`
    ]
  },
  {
    heading: '2. Hosting und Server-Logfiles',
    lines: [
      'Beim Aufruf dieser Seite verarbeitet der Hosting-Anbieter technisch notwendige Daten wie IP-Adresse, Datum und Uhrzeit, aufgerufene Seite und Browsertyp. Diese Daten dienen dem sicheren und stabilen Betrieb der Seite.'
    ]
  },
  {
    heading: '3. Cookies und Tracking',
    lines: [
      'Diese Seite setzt selbst keine Cookies und verwendet keine Analyse- oder Tracking-Tools.'
    ]
  },
  {
    heading: '4. Schriftarten',
    lines: [
      'Zur Darstellung können Schriftarten von Google Fonts geladen werden. Dabei wird deine IP-Adresse an Server von Google übertragen.'
    ]
  },
  {
    heading: '5. Externe Links',
    lines: [
      'Beim Klick auf Links zu Amazon verlässt du diese Seite. Für die Datenverarbeitung dort gilt die Datenschutzerklärung von Amazon.'
    ]
  },
  {
    heading: '6. Kontaktaufnahme',
    lines: [
      `Wenn du uns per E-Mail kontaktierst, speichern wir deine Angaben zur Bearbeitung der Anfrage. Kontakt: ${OWNER.email}`
    ]
  },
  {
    heading: '7. Deine Rechte',
    lines: [
      'Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Schreibe dazu einfach an die oben genannte E-Mail-Adresse.'
    ]
  }
];